import { ApiStoryResponse } from '../../../api/core/models';
import { BoardSettingsV2 } from '../model';

export function emissionStoryToEmissionPathways(
  emissionStory?: ApiStoryResponse
): BoardSettingsV2['emissionsPathways'] {
  if (!emissionStory) {
    return undefined;
  }
  return {
    title: emissionStory.title,
    description: emissionStory.description ?? '',
    ...(emissionStory?.imgUrl ? { image: emissionStory.imgUrl } : {}),
    ...(emissionStory?.imageCredits ? { imageCredit: emissionStory.imageCredits } : {}),
  };
}
